import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20lace%20fabric%20draped%20gracefully%20with%20soft%20natural%20light%2C%20delicate%20floral%20lace%20patterns%20in%20cream%20and%20ivory%20tones%2C%20luxury%20textile%20art%20photography%2C%20dreamy%20romantic%20atmosphere%2C%20high%20fashion%20editorial%20style%2C%20soft%20shadows%20and%20highlights%2C%20warm%20neutral%20aesthetic&width=1920&height=1080&seq=hero-lace-2026&orientation=landscape"
        alt="精致蕾丝面料"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <p className="text-accent-300 text-sm md:text-base tracking-[0.3em] uppercase mb-4 font-label">
          精致优雅的时尚之选
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-background-50 max-w-3xl leading-tight mb-6">
          探索蕾丝的
          <span className="text-accent-300">无限魅力</span>
        </h1>
        <p className="text-background-200/90 text-base md:text-lg max-w-2xl leading-relaxed mb-8">
          蕾丝以其精致镂空工艺演绎永恒优雅，从高级定制到日常生活，<br className="hidden sm:block" />
          让每一件蕾丝单品成为你衣橱中的经典珍藏。
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/category/lace-fabric-types"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            探索蕾丝种类
          </Link>
          <Link
            to="/category/lace-dress"
            className="px-8 py-3 border border-background-50/40 hover:border-background-50 text-background-50 font-medium rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-sm hover:bg-background-50/10"
          >
            选购指南
          </Link>
        </div>
      </div>
    </section>
  );
}